<template>
    <nav class="navbar-default">
        <ul class="depth-1" id="metismenu">
            <li class="nav-header">
                <img :alt="getUserFullName" class="profile-img-sm rounded-circle mb-2"
                     src="../../assets/img/new-kpi-logo.svg">
                <div class="nav-header-text">
                    <div class="font-weight-bold">{{ getUserFullName }}</div>
                </div>
                <div class="clear-both"></div>
            </li>
            <li>
                <router-link to="/timesheet">
                    <i class="fas fa-file-signature"></i>
                    <span class="nav-label">Add Timesheet</span>
                </router-link>
                <div class="clear-both"></div>
            </li>
        </ul>
    </nav>
</template>

<script>
    import {mapGetters} from 'vuex'

    // require('../../../static/metisMenu.min')

    export default {
        name: 'SideBar',
        data() {
            return {
                items: [],
                expanded: 'aria-expanded'
            }
        },
        methods: {
            hasChild(item) {
                return item.children && item.children.length > 0
            },
        },
        computed: {
            ...mapGetters({
                getUserFullName: 'getUserFullName'
            })
        },
        async mounted() {
        }
    }
</script>

<style scoped>

</style>
